import styled, { css } from 'styled-components'

export const CheckboxRow = styled.label(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    gap: ${theme.space['8']};
    margin-top: ${theme.space['16']};
    cursor: pointer;
    font-size: 1.4rem;
  `,
)
